import { useQuery } from "@tanstack/react-query";
import plansAdminService from "services/admin/plansService";
import { Plan } from "interfaces/entities/plan.interface";

export const useGetPlans = (orgID: string) => {
    return useQuery({
        queryKey: ['plans', orgID],
        queryFn: async () => {
            const response: any = await plansAdminService.getAll()
            return response.data as Plan[]
        },
        select: (data) => data,
    })
}